//Update this
const LICENSE_API = "https://d19xvu9xayq73j.cloudfront.net/api/get-license-url"; 
//const SHOP_DOMAIN = 'my-shop.myshopify.com';
const SHOP_DOMAIN = window.Shopify?.shop || window.location.hostname;

const CACHE_KEY = "modelViewerLicense";
const CACHE_TTL_MS = 12 * 60 * 60 * 1000;

export async function checkLicense() {
  try {
    //const res = await fetch(signedUrl);
    console.log("Checking license...:", `${LICENSE_API}?domain=${SHOP_DOMAIN}`);

    // Get signed URL from API
    const res = await fetch(`${LICENSE_API}?domain=${SHOP_DOMAIN}`);
    if (!res.ok) throw new Error("Failed to get signed URL");
    const { signedUrl } = await res.json();

    // Fetch actual license file
    const licenseRes = await fetch(signedUrl);
    if (!licenseRes.ok) throw new Error("Failed to fetch license file");
    const license = await licenseRes.json();

    const isValid = license.status === "valid";

    window.ModelViewerLicense = isValid;
    return isValid;
  } catch (err) {
    console.error("License check failed", err);
    window.ModelViewerLicense = false;
    return false;
  }
}
